//removeIf(production)
import ClaroluzModalGeneric from '../../shared/modal/modal-generic';
import ClaroluzModalInit from '../../shared/modal/modal-init';
import claroluzActionBox from '../action-box/action-box';
import ClaroluzCups from '../cups/cups';
import ClaroluzDropzonePdf from '../pdf/dropzone-pdf';
import ClaroluzQrWorker from '../qr-code/qr-code';
import ClaroluzQrWorkerLegacy from '../qr-code/qr-code-legacy';
import ClaroluzReset from './reset';
import ClaroluzSubmit from './submit';
import ClaroluzValidation from './validation.4';
//endRemoveIf(production)

if (document.querySelector('.claroluz-uploader')) {
    new claroluzActionBox();
    new ClaroluzValidation();
    // new ClaroluzQrWorker('.claroluz-uploader', 'type-pdf');
    new ClaroluzQrWorkerLegacy('.claroluz-uploader', 'type-pdf');
    new ClaroluzDropzonePdf();
    new ClaroluzSubmit();
    new ClaroluzCups();
    new ClaroluzReset();

    new ClaroluzModalGeneric('#claroluz-modal-pdf-tutorial', '.claroluz-pdf-tutorial');
    new ClaroluzModalGeneric('#claroluz-modal-cups-tutorial', '.claroluz-cups-tutorial');
    new ClaroluzModalInit();
}